export default __webpack_public_path__ + "static/GT-America-Standard-Regular-Italic-560eb2a1db6893b21852b755d8acea58.ttf";